var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"infoHeader"},[_c('div',{staticClass:"fixation"},[_c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("../../../assets/index-logo.png"),"alt":""}})])],1),_c('div',{staticClass:"title"},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.title)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }